"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pescate": {
    "57412e57": [{
      "hkey": "58d95380",
      "slug": "pescate",
      "name": "Pescate",
      "primary": true,
      "skipSearch": false
    }],
    "insirano": [{
      "hkey": "58d95380",
      "slug": "pescate",
      "name": "Pescate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "19d13719": [{
      "hkey": "58d95380",
      "slug": "pescate",
      "name": "Pescate",
      "primary": true,
      "skipSearch": false
    }],
    "pescalina": [{
      "hkey": "58d95380",
      "slug": "pescate",
      "name": "Pescate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "93a8f8b2": [{
      "hkey": "58d95380",
      "slug": "pescate",
      "name": "Pescate",
      "primary": true,
      "skipSearch": false
    }],
    "torrette-inferiori": [{
      "hkey": "58d95380",
      "slug": "pescate",
      "name": "Pescate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1801e75f": [{
      "hkey": "58d95380",
      "slug": "pescate",
      "name": "Pescate",
      "primary": true,
      "skipSearch": false
    }],
    "torrette-superiori": [{
      "hkey": "58d95380",
      "slug": "pescate",
      "name": "Pescate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;